import React from 'react';

import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroBanner from "../components/teacher-terms/HeroBanner";
import TermCondition from "../components/teacher-terms/TermCondition";


export default function TeacherTerms() {
    return (
        <>
            <Header />

            <HeroBanner />

            <TermCondition />

            <Footer />
        </>
    );
}